import React, { useEffect, useRef } from "react";
import {
  ImageContainer,
  ImageCredits,
  ImageCreditsContainer,
  SmallHeading,
  Wrapper,
} from "../styles/components/Galleries/Global";
import ImageDisplay from "./Image";
import animations from "./Animations";

const GalleryImages = ({
  images,
  parallax = false,
  mobile = false,
  quote = false,
}) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (parallax) {
      setTimeout(() => {
        animations.parallax(containerRef.current);
      }, 1000);
    }
  }, []);

  return (
    <Wrapper ref={containerRef} $flex $mobile={mobile}>
      {images?.map((image, index) => (
        <ImageContainer
          key={index}
          $margin={index !== 0}
          $split={images.length > 1}
          $balance={image.balance}
        >
          <ImageDisplay src={image.src} mobile={image.mobile} quote={quote} />
          <ImageCreditsContainer
            $balance={image.balance}
            $widthSize={image.widthSize}
            $flex={image.title}
          >
            {image.title && (
              <ImageCredits $title $align="flex-start" $justify="flex-start">
                <SmallHeading>{image.title}</SmallHeading>
              </ImageCredits>
            )}
            {image.credits && (
              <ImageCredits $justify={image.justify} $padding={image.padding}>
                <SmallHeading $indent={image.indent}>
                  {image.credits}
                </SmallHeading>
              </ImageCredits>
            )}
          </ImageCreditsContainer>
        </ImageContainer>
      ))}
    </Wrapper>
  );
};

export default GalleryImages;
